module.exports = __webpack_public_path__ + "static/media/logo-eventtia-white.8f03d11b.png";